"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useResolvedTheme } from "@/lib/hooks/use-resolved-theme";

export function ThemeToggle() {
  const { mounted, isDark, setTheme } = useResolvedTheme();

  if (!mounted) {
    return <div className="inline-flex items-center justify-center h-9 w-9" aria-hidden="true" />;
  }

  return (
    <button
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="relative inline-flex items-center justify-center rounded-full text-sm font-medium transition-colors hover:bg-zinc-100 hover:text-zinc-900 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-zinc-950 dark:hover:bg-zinc-800 dark:hover:text-zinc-50 h-9 w-9"
      aria-label="Toggle theme"
    >
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-zinc-950 dark:text-zinc-50" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-zinc-950 dark:text-zinc-50" />
    </button>
  );
}
